import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useInView } from 'react-intersection-observer';
import { Link } from 'react-router-dom';

const ContactStrip: React.FC = () => {
  const { t } = useTranslation('home');
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section className="py-20" ref={ref}>
      <div className="container-custom">
        <motion.div
          className="card p-12 text-center bg-gradient-to-br from-primary-900/30 to-primary-700/30"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            {t('contactStrip.title')}
          </h2>
          <p className="text-xl text-secondary mb-8 max-w-2xl mx-auto">
            {t('contactStrip.subtitle')}
          </p>
          <Link to="/contact" className="btn-primary">
            {t('contactStrip.cta')}
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default ContactStrip;
